import styled from 'styled-components'
import { FormGroup as FormGroupOriginal, FormFeedback } from 'reactstrap'

import { COLOURS, BREAKPOINTS } from 'resources'

import RoundedButton from 'components/RoundedButton'
import VerificationCodeInput from 'components/VerificationCodeInput'

export const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-direction: column;
  max-width: 350px;
  width: 100%;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  text-align: left;
  margin: 50px 0;
`

export const Title = styled.div`
  font-family: Druk, sans-serif;
  font-weight: bold;
  font-size: 45px;
  line-height: 1;
  margin-bottom: 10px;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 60px;
  }
`

export const Text = styled.div`
  font-size: 20px;
  line-height: 26px;
`

export const TextPurple = styled(Text)`
  color: ${COLOURS.secondaryPurple1};
  word-break: break-word;
`

export const WelcomeMessageContainer = styled.div`
  margin-top: 15px;
  font-family: 'Druk', sans-serif;
  font-size: 80px;
  line-height: 1;
  justify-content: column;
`

export const WelcomeMessageText = styled.span``

export const WelcomeMessageRedText = styled.span`
  color: ${COLOURS.secondaryRed1};
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
`

export const FormGroup = styled(FormGroupOriginal)`
  margin-top: 35px;
  margin-bottom: 30px;
`

export const FormResponse = styled(FormFeedback)`
  padding-left: 0.25rem !important;
`

export const ResendCodeButton = styled.button`
  margin: 30px auto 20px 0;
  background: none;
  border: none;
  color: ${COLOURS.primaryBlue};
  transition: all 0.3s;

  &:disabled {
    color: ${COLOURS.lightGrey};
    cursor: not-allowed;
  }

  &:hover:enabled {
    opacity: 0.7;
  }
`

export const SignInButton = styled(RoundedButton)`
  margin-top: 12px;
`

export const VerifyCodeInput = styled(VerificationCodeInput)`
  && {
    width: 100%;
    font-size: 22px;
    line-height: 35px;
    border-radius: 0;
  }
`
